import { supabase } from '@/lib/supabase'

export function buildResetRedirectUrl(): string {
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : ''
    if (!origin) return 'http://localhost:1000/reset-password'
    return `${origin}/reset-password`
  } catch {
    return 'http://localhost:1000/reset-password'
  }
}

export async function requestPasswordReset(email: string) {
  const redirectTo = buildResetRedirectUrl()
  try {
    // Usa Supabase Functions (biblioteca inclui Authorization/apikey automaticamente)
    const { data, error } = await (supabase as any).functions.invoke('auth-send-recovery-email', {
      body: { email, redirectTo },
    })
    if (!error && data?.ok === true) {
      return { data, error: null }
    }
    // Fallback: mailer nativo do Supabase (requer SMTP configurado)
    return await supabase.auth.resetPasswordForEmail(email, { redirectTo })
  } catch {
    // Fallback em caso de exceção de rede
    return supabase.auth.resetPasswordForEmail(email, { redirectTo })
  }
}

export async function updatePassword(newPassword: string) {
  return supabase.auth.updateUser({ password: newPassword })
}

